import SortIcon from '../svgs/SortIcon'
import { css, StyleSheet } from 'aphrodite'

const SortButton = ({ clickHandler }) => {
	return (
		<button className={css(styles.btn)} onClick={clickHandler}>
			<SortIcon />
		</button>
	)
}

export default SortButton

const styles = StyleSheet.create({
	btn: {
		border: 0,
		background: 'none',
		padding: 0,
		alignSelf: 'center',
		lineHeight: 0,
		':hover': {
			cursor: 'pointer',
		},
	},
})
